import React from "react";
import AuthService from "services/auth";

import "./style.scss";

import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/TextField";
import ClipLoader from "react-spinners/ClipLoader";
export default class extends React.Component {
  authService = new AuthService();
  state = {
    email: null,
    password: null,
    isLoading: false,
    hasFailed: false,
    isValid: false,
  };

  onUpdate(data) {
    this.setState({
      ...data,
    });
  }

  onEmailInput(email) {
    const { password } = this.state;

    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!re.test(email)) {
      email = null;
    }

    const isValid = email && email !== "" && password && password !== "";
    this.onUpdate({ email, isValid });
  }
  onPasswordInput(password) {
    const { email } = this.state;

    const isValid = email && email !== "" && password && password !== "";
    this.onUpdate({ password, isValid });
  }

  async onConfirm() {
    const { email, password, isLoading } = this.state;

    this.setState({ isLoading: true });

    const token = await this.authService
      .create({ email, password })
      .then(({ data }) => data);

    if (!token.success) {
      return this.setState({ isLoading: false, hasFailed: true });
    }

    const { data } = token;

    localStorage.setItem("token", data);

    this.props.onLoggedIn();
  }

  render() {
    const { email, isLoading, hasFailed, isValid } = this.state;

    return isLoading ? (
      <div className="sign-in-spinner">
        <ClipLoader size={32} color="#999" />
      </div>
    ) : (
      <div className="sign-in-form">
        {hasFailed ? <p>Failed to login with those credentials</p> : null}
        <div className="input">
          <Input
            type="email"
            label="Email address"
            placeholder="Enter your email address"
            variant="filled"
            defaultValue={email}
            fullWidth
            onChange={(e) => this.onEmailInput(e.target.value)}
          />
        </div>
        <div className="input">
          <Input
            type="password"
            label="Password"
            placeholder="Enter your password"
            variant="filled"
            fullWidth
            onChange={(e) => this.onPasswordInput(e.target.value)}
          />
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={() => this.onConfirm()}
          disabled={!isValid}
        >
          Sign in
        </Button>
      </div>
    );
  }
}
